import { toast } from 'sonner';
import axiosInstance from '../axiosInstance';

// Action Types
export const FETCH_WASTAGE_SUMMARY_REQUEST = 'FETCH_WASTAGE_SUMMARY_REQUEST';
export const FETCH_WASTAGE_SUMMARY_SUCCESS = 'FETCH_WASTAGE_SUMMARY_SUCCESS';
export const FETCH_WASTAGE_SUMMARY_FAILURE = 'FETCH_WASTAGE_SUMMARY_FAILURE';

export const FETCH_WASTAGE_BY_PURCHASE_REQUEST = 'FETCH_WASTAGE_BY_PURCHASE_REQUEST';
export const FETCH_WASTAGE_BY_PURCHASE_SUCCESS = 'FETCH_WASTAGE_BY_PURCHASE_SUCCESS';
export const FETCH_WASTAGE_BY_PURCHASE_FAILURE = 'FETCH_WASTAGE_BY_PURCHASE_FAILURE';

export const FETCH_WASTAGE_BY_PRODUCT_REQUEST = 'FETCH_WASTAGE_BY_PRODUCT_REQUEST';
export const FETCH_WASTAGE_BY_PRODUCT_SUCCESS = 'FETCH_WASTAGE_BY_PRODUCT_SUCCESS';
export const FETCH_WASTAGE_BY_PRODUCT_FAILURE = 'FETCH_WASTAGE_BY_PRODUCT_FAILURE';

export const FETCH_DETAILED_WASTAGE_REQUEST = 'FETCH_DETAILED_WASTAGE_REQUEST';
export const FETCH_DETAILED_WASTAGE_SUCCESS = 'FETCH_DETAILED_WASTAGE_SUCCESS';
export const FETCH_DETAILED_WASTAGE_FAILURE = 'FETCH_DETAILED_WASTAGE_FAILURE';

export const FETCH_MANUAL_WASTAGE_REQUEST = 'FETCH_MANUAL_WASTAGE_REQUEST';
export const FETCH_MANUAL_WASTAGE_SUCCESS = 'FETCH_MANUAL_WASTAGE_SUCCESS';
export const FETCH_MANUAL_WASTAGE_FAILURE = 'FETCH_MANUAL_WASTAGE_FAILURE';

export const ADD_WASTAGE_REQUEST = 'ADD_WASTAGE_REQUEST';
export const ADD_WASTAGE_SUCCESS = 'ADD_WASTAGE_SUCCESS';
export const ADD_WASTAGE_FAILURE = 'ADD_WASTAGE_FAILURE';


// Fetch Wastage Summary
export const Fetch_WastageSummary =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_WASTAGE_SUMMARY_REQUEST });

    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axiosInstance.get(`wastage-report/summary?${queryString}`);

      dispatch({
        type: FETCH_WASTAGE_SUMMARY_SUCCESS,
        payload: response.data.data
      });

      return response.data;
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Failed to fetch wastage summary';
      dispatch({
        type: FETCH_WASTAGE_SUMMARY_FAILURE,
        payload: errorMsg
      });
      toast.error(errorMsg);
      throw error;
    }
  };

// Fetch Wastage by Purchase Order
export const Fetch_WastageByPurchase =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_WASTAGE_BY_PURCHASE_REQUEST });

    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axiosInstance.get(`wastage-report/by-purchase?${queryString}`);

      dispatch({
        type: FETCH_WASTAGE_BY_PURCHASE_SUCCESS,
        payload: response.data.data
      });

      return response.data;
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Failed to fetch wastage by purchase';
      dispatch({
        type: FETCH_WASTAGE_BY_PURCHASE_FAILURE,
        payload: errorMsg
      });
      toast.error(errorMsg);
      throw error;
    }
  };

// Fetch Wastage by Product
export const Fetch_WastageByProduct =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_WASTAGE_BY_PRODUCT_REQUEST });

    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axiosInstance.get(`wastage-report/by-product?${queryString}`);

      dispatch({
        type: FETCH_WASTAGE_BY_PRODUCT_SUCCESS,
        payload: response.data.data
      });

      return response.data;
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Failed to fetch wastage by product';
      dispatch({
        type: FETCH_WASTAGE_BY_PRODUCT_FAILURE,
        payload: errorMsg
      });
      toast.error(errorMsg);
      throw error;
    }
  };

// Fetch Manual Wastage
export const Fetch_Manual_Wastage =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_MANUAL_WASTAGE_REQUEST });

    try {
      const {
        start_date,
        end_date,
        warehouse_id,
        product_id,
        company_id,
        limit = 100,
        offset = 0,
        month
      } = params;

      const queryParams = new URLSearchParams();
      if (start_date) queryParams.append('start_date', start_date);
      if (end_date) queryParams.append('end_date', end_date);
      if (warehouse_id) queryParams.append('warehouse_id', warehouse_id);
      if (product_id) queryParams.append('product_id', product_id);
      if (company_id) queryParams.append('company_id', company_id);
      if (limit) queryParams.append('limit', limit);
      if (offset !== undefined) queryParams.append('offset', offset);
      if (month) queryParams.append('month', month);

      const response = await axiosInstance.get(`wastage-report/manual?${queryParams.toString()}`);

      dispatch({
        type: FETCH_MANUAL_WASTAGE_SUCCESS,
        payload: response.data.data
      });

      return response.data;
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Failed to fetch manual wastage';
      dispatch({
        type: FETCH_MANUAL_WASTAGE_FAILURE,
        payload: errorMsg
      });
      toast.error(errorMsg);
      throw error;
    }
  };

// Add Wastage
export const Add_Wastage = (wastageData) => async (dispatch) => {
  dispatch({ type: ADD_WASTAGE_REQUEST });

  try {
    const response = await axiosInstance.post('/wastage', wastageData);

    dispatch({
      type: ADD_WASTAGE_SUCCESS,
      payload: response.data.data
    });

    toast.success('Wastage added successfully');
    return response.data;
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Failed to add wastage';
    dispatch({
      type: ADD_WASTAGE_FAILURE,
      payload: errorMsg
    });
    toast.error(errorMsg);
    throw error;
  }
};

// Fetch Detailed Wastage Report
export const Fetch_DetailedWastage =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_DETAILED_WASTAGE_REQUEST });

    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axiosInstance.get(`wastage-report/detailed?${queryString}`);

      dispatch({
        type: FETCH_DETAILED_WASTAGE_SUCCESS,
        payload: response.data.data
      });

      return response.data;
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Failed to fetch detailed wastage report';
      dispatch({
        type: FETCH_DETAILED_WASTAGE_FAILURE,
        payload: errorMsg
      });
      toast.error(errorMsg);
      throw error;
    }
  };
